import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'jurisdictionAbbreviation',
    standalone: false
})
// NOTE: Only use this if you do not have an Order and Order.DisplayJurisdiction is unavailable
// this does the same thing, so if you already have access to the Order, don't do the extra work.
export class JurisdictionAbbreviationPipe implements PipeTransform {
    transform(jurisdiction: string, country: string) {
        if (country === 'CA') {
            switch (jurisdiction?.toUpperCase()) {
                case 'BRITISH COLUMBIA': 
                case "COLOMBIE-BRITANNIQUE": return 'BC';
                case 'ALBERTA': return 'AB';
                case 'SASKATCHEWAN': return 'SK';
                case 'MANITOBA': return 'MB';
                case 'ONTARIO': return 'ON';
                case 'QUEBEC': 
                case "QUÉBEC": return 'QC';
                case 'YUKON': return 'YT';
                case 'NORTHWEST TERRITORIES': 
                case "NORTHWEST TERRITORY":
                case "TERRITOIRES DU NORD-OUEST": return 'NT';
                case 'NUNAVUT': return 'NU';
                case 'NEWFOUNDLAND AND LABRADOR': 
                case "TERRE-NEUVE-ET-LABRADOR": return 'NL';
                case 'NEW BRUNSWICK': 
                case "NOUVEAU-BRUNSWICK": return 'NB';
                case 'NOVA SCOTIA': 
                case "NOUVELLE-ÉCOSSE": return 'NS';
                case 'PRINCE EDWARD ISLAND':
                case "ÎLE-DU-PRINCE-ÉDOUARD":
                case "ILE-DU-PRINCE-EDOUARD": return 'PE';
                case 'FEDERAL': 
                case "FÉDÉRAL": return '_F';
                case 'MULTIPLE': return '_M';
                default: return '';
            }
        } else if (country === 'US') {
            switch (jurisdiction?.toUpperCase()) {
                case 'ALABAMA': return 'AL';
                case 'ALASKA': return 'AK';
                case 'ARIZONA': return 'AZ';
                case 'ARKANSAS': return 'AR';
                case 'CALIFORNIA': return 'CA';
                case 'COLORADO': return 'CO';
                case 'CONNECTICUT': return 'CT';
                case 'DELAWARE': return 'DE';
                case 'FLORIDA': return 'FL';
                case 'GEORGIA': return 'GA';
                case 'HAWAII': return 'HI';
                case 'IDAHO': return 'ID';
                case 'ILLINOIS': return 'IL';
                case 'INDIANA': return 'IN';
                case 'IOWA': return 'IA';
                case 'KANSAS': return 'KS';
                case 'KENTUCKY': return 'KY';
                case 'LOUISIANA': return 'LA';
                case 'MAINE': return 'ME';
                case 'MARYLAND': return 'MD';
                case 'MASSACHUSETTS': return 'MA';
                case 'MICHIGAN': return 'MI';
                case 'MINNESOTA': return 'MN';
                case 'MISSISSIPPI': return 'MS';
                case 'MISSOURI': return 'MO';
                case 'MONTANA': return 'MT';
                case 'NEBRASKA': return 'NE';
                case 'NEVADA': return 'NV';
                case 'NEW HAMPSHIRE': return 'NH';
                case 'NEW JERSEY': return 'NJ';
                case 'NEW MEXICO': return 'NM';
                case 'NEW YORK': return 'NY';
                case 'NORTH CAROLINA': return 'NC';
                case 'NORTH DAKOTA': return 'ND';
                case 'OHIO': return 'OH';
                case 'OKLAHOMA': return 'OK';
                case 'OREGON': return 'OR';
                case 'PENNSYLVANIA': return 'PA';
                case 'RHODE ISLAND': return 'RI';
                case 'SOUTH CAROLINA': return 'SC';
                case 'SOUTH DAKOTA': return 'SD';
                case 'TENNESSEE': return 'TN';
                case 'TEXAS': return 'TX';
                case 'UTAH': return 'UT';
                case 'VERMONT': return 'VT';
                case 'VIRGINIA': return 'VA';
                case 'WASHINGTON': return 'WA';
                case 'WEST VIRGINIA': return 'WV';
                case 'WISCONSIN': return 'WI';
                case 'WYOMING': return 'WY';
                case 'DISTRICT OF COLUMBIA': return 'DC';
                case 'AMERICAN SAMOA': return 'AS';
                case 'GUAM': return 'GU';
                case 'NORTHERN MARIANA ISLANDS': return 'MP';
                case 'PUERTO RICO': return 'PR';
                case 'VIRGIN ISLANDS': return 'VI';
                case 'ARMED FORCES (AMERICAS)': return 'AA';
                case 'ARMED FORCES (OTHER)': return 'AE';
                case 'ARMED FORCES (PACIFIC)': return 'AP';
                default: return '';
            }
        } else {
            return jurisdiction;
        }
    }
}